import {isError} from 'lodash';

/**
 * Class representing an error.
 * Here we are transforming the data to correctly pass information for tracking errors.
 * Since the firebase library takes the message from the error, we need to make it more clear.
 * @extends Error
 */
export class BaseError extends Error {
  /**
   * @param {object} params - Parameters
   * @param {number} params.name - error name
   * @param {object|string} params.error - error object or error message
   */
  constructor({name = 'Error', error = {}}) {
    super();

    this.name = name;

    if (isError(error)) {
      this.message = `[${name}] ${error.message}`;
    } else {
      this.message = `[${name}] ${error}`;
    }
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  toString = () => {
    return `${this.message}`;
  };
}
